export const AppStorageType = {
  fileSystem: "filesystem",
  s3: "s3",
};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/models/AppStorageType.ts